export default __webpack_public_path__ + "static/media/qrcode-open-app-stg.0e9ec550.jpg";